import { ILogger } from '@cian/logger';
import loadable from '@loadable/component';
import * as React from 'react';

import { IRegion } from '../../../../node/types/region';
import { TJsonQuery } from '../../../../packages/JsonQuery';
import { LoadableErrorBoundary, LoadableFallback } from '../../../../packages/LoadableHelpers';
import { ModalWindow } from '../../../../packages/ModalWindow';

export interface IRegionSelectContainerModalProps {
  logger: ILogger;
  regions: IRegion[] | null;
  onClose(nextJsonQuery?: TJsonQuery): void;
}

const RegionSelectContainerLoadable = loadable(() => import('./RegionSelectContainer'), {
  fallback: <LoadableFallback />,
  ssr: false,
});

export const RegionSelectContainerModal: React.FC<IRegionSelectContainerModalProps> = ({
  logger,
  regions,
  onClose,
}) => {
  const modalWindowRef = React.createRef<ModalWindow>();

  const handleRetry = React.useCallback(() => {
    RegionSelectContainerLoadable.load();
  }, []);

  const handleScrollableChange = React.useCallback(() => {
    if (modalWindowRef.current) {
      modalWindowRef.current.scrollToTop();
    }
  }, [modalWindowRef]);

  return (
    <LoadableErrorBoundary logger={logger} onRetry={handleRetry}>
      <RegionSelectContainerLoadable regions={regions} onQueryChange={handleScrollableChange} onClose={onClose} />
    </LoadableErrorBoundary>
  );
};
